import { render, staticRenderFns } from "./DebugPanel.vue?vue&type=template&id=32159956&"
import script from "./DebugPanel.vue?vue&type=script&lang=ts&"
export * from "./DebugPanel.vue?vue&type=script&lang=ts&"
import style0 from "./DebugPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports